var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPossibleLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 24,
    viewBox: "0 0 126 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_1793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0388 0.197906H0.261047V11.9631H12.0388V0.197906Z",
    fill: "#0577FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0388 11.9631H0.261047V23.7282H12.0388V11.9631Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4023 0.170593H25.2403C29.7168 0.170593 32.6795 2.86302 32.6795 6.96961C32.6795 11.0762 29.7175 13.7679 25.241 13.7679H19.4662V23.7312H16.4023V0.170593ZM24.9375 11.1094C27.7651 11.1094 29.6156 9.4597 29.6156 6.96961C29.6156 4.47952 27.7651 2.82906 24.9375 2.82906H19.4655V11.1094H24.9375Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2121 15.2492C32.2121 10.1332 35.8135 6.49847 40.7945 6.49847C45.7754 6.49847 49.3776 10.1332 49.3776 15.2492C49.3776 20.3653 45.7422 24 40.7945 24C35.8135 24 32.2121 20.3653 32.2121 15.2492ZM40.7945 21.476C44.0932 21.476 46.4489 18.9179 46.4489 15.2492C46.4489 11.5466 44.0932 8.98857 40.7945 8.98857C37.4958 8.98857 35.1401 11.5466 35.1401 15.2492C35.1401 18.9179 37.4965 21.476 40.7945 21.476Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5887 18.1772H53.4834C53.719 20.3313 55.1324 21.5431 57.3234 21.5431C59.4103 21.5431 60.7203 20.6341 60.7203 18.8847C60.7203 14.7116 51.0273 17.3339 51.0273 11.0762C51.0273 8.48491 53.383 6.49771 56.7821 6.49771C60.4848 6.49771 62.8375 8.31507 63.3123 11.5798H60.4176C60.182 9.86288 58.7007 8.95457 56.7821 8.95457C55.1332 8.95457 53.8541 9.62731 53.8541 10.9735C53.8541 14.8135 63.6151 11.9837 63.6151 18.816C63.6151 21.8791 60.9899 23.9993 57.3212 23.9993C52.9451 24 50.7571 21.106 50.5887 18.1772Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.917 18.1772H67.8118C68.0474 20.3313 69.4608 21.5431 71.6518 21.5431C73.7387 21.5431 75.0487 20.6341 75.0487 18.8847C75.0487 14.7116 65.3557 17.3339 65.3557 11.0762C65.3557 8.48491 67.7114 6.49771 71.1113 6.49771C74.8132 6.49771 77.1666 8.31507 77.6407 11.5798H74.746C74.5104 9.86288 73.0298 8.95457 71.1113 8.95457C69.4615 8.95457 68.1825 9.62731 68.1825 10.9735C68.1825 14.8135 77.9435 11.9837 77.9435 18.816C77.9435 21.8791 75.3183 23.9993 71.6496 23.9993C67.2735 24 65.0854 21.106 64.917 18.1772Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0673 6.76727H82.9621V23.7312H80.0673V6.76727Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6209 20.9376V23.7312H85.7262V0.0450439H88.6209V9.52616C89.5972 7.67483 91.9529 6.49846 94.4777 6.49846C99.5597 6.49846 102.926 9.99877 102.926 15.2492C102.926 20.4997 99.5597 24 94.4777 24C91.9868 24 89.5972 22.7882 88.6209 20.9376ZM94.3071 21.5099C97.5718 21.5099 99.9932 18.9519 99.9932 15.2492C99.9932 11.5466 97.5696 8.98855 94.3071 8.98855C90.9751 8.98855 88.6209 11.5466 88.6209 15.2492C88.6209 18.9179 90.9773 21.5099 94.3093 21.5099H94.3071Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.801 0.0184631H107.695V23.7312H104.801V0.0184631Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57 15.2492C109.57 10.1332 113.071 6.49847 117.884 6.49847C123.067 6.49847 126.302 10.5371 125.659 15.6192H112.498C112.633 19.2207 114.788 21.5099 117.985 21.5099C120.442 21.5099 122.058 20.2641 122.596 18.3124H125.491C124.885 21.6103 121.991 23.9985 118.086 23.9985C113.071 24 109.57 20.3653 109.57 15.2492ZM122.73 13.3292C122.73 10.6368 120.745 8.95386 117.884 8.95386C115.124 8.95386 113.239 10.5046 112.667 13.3292H122.73Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4815 0C82.6254 0 83.4672 0.807877 83.4672 1.92C83.4672 3.03212 82.6254 3.84 81.4815 3.84C80.3738 3.84 79.529 3.03212 79.529 1.92C79.529 0.807877 80.3708 0 81.4815 0Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_1793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.478,
    height: 24,
    fill: "white",
    transform: "translate(0.261047)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPossibleLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PossibleLogo.522ad7bc3a35e833f559fa91a4dc97d0.svg";